import PersonSkillEdit from "../Edits/PersonSkillEdit";
import CmModal from "../Controls/CmModal";
import { usePersonSkillsQuery } from "../../query/usePersonSkills";

export default function PersonSkillEditModal({ personSkillId = 0, onClose }) {
  const id = Number.parseInt(personSkillId, 10) || 0;
  const { data } = usePersonSkillsQuery();
  const row = (data?.personSkills || []).find((ps) => Number(ps.ID || ps.id) === id);
  const name =
    id > 0 ? row?.SkillName || row?.skillName || "Your skill" : "Add skill";

  const title = (
    <>
      <span>{name}</span>
      {id > 0 ? (
        <span className="cm-modal-title-id" data-testid="person-skill-modal-id">
          ({id})
        </span>
      ) : null}
    </>
  );

  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title={title}
      size="xl"
      testId="person-skill-edit-modal"
      className="person-skill-modal"
    >
      <PersonSkillEdit personSkillId={id} onClose={onClose} />
    </CmModal>
  );
}
